<script lang="ts">
  import { goto } from '$app/navigation';
  import LL from '$i18n/i18n-svelte';
  import { getTranslatedCharacterName } from '$lib/er/character/translations';
  import CharacterIcon from '$lib/er/character/character-icon.svelte';
  import { idToCharacterWeapon } from '$lib/er/item/stores';
  import type { ResultOf } from '$lib/erar/api';
  import { orderBy } from '$lib/utils/array';
  import { trimTrailingZero } from '$lib/utils/number';
  import { CharacterImageType } from '$lib/er/character/consts';

  export let characters: ResultOf<'GET /player/[id]/statistics'>['characters'];

  $: sortedCharacterEntries = Object.entries(characters)
    .sort(orderBy((v) => v[1].playTime, true))
    .map((v) => [parseInt(v[0]), v[1]] as const);

  const summaryCutCount = 3;
  let showAll = false;
</script>

<section class="panel">
  <h2>실험체</h2>
  <table>
    <thead>
      <th>실험체</th>
      <th>승률</th>
      <th>반타작률</th>
      <th>평균 킬</th>
    </thead>
    <tbody>
      {#each sortedCharacterEntries.slice(0, showAll ? undefined : summaryCutCount) as [characterId, stat]}
        <tr on:click={() => goto(`/database/characters/${characterId}`)}>
          <td class="character">
            <CharacterIcon id={characterId} type={CharacterImageType.Lobby} skinIndex={0} />
            <div>
              <span>{getTranslatedCharacterName($LL, characterId)}</span>
              <span class="time"
                >{stat.plays}회({trimTrailingZero(stat.playTime / 60 / 60, 1)}시간)</span
              >
            </div>
          </td>
          <td>{trimTrailingZero((stat.wins / stat.plays) * 100, 1)}%</td>
          <td>{trimTrailingZero(stat.halfRate * 100, 1)}%</td>
          <td>{trimTrailingZero(stat.kda[0] / stat.plays, 1)}</td>
        </tr>
      {/each}
    </tbody>
  </table>
  {#if sortedCharacterEntries.length > summaryCutCount}
    <button class="show-all-button" on:click={() => (showAll = !showAll)}>
      {#if showAll}
        요약 보기
      {:else}
        모두 보기
      {/if}
    </button>
  {/if}
</section>

<style lang="postcss">
  @import '$lib/styles/breakpoints.css';

  .panel {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-size: var(--size-5);
  }

  table {
    border-spacing: 0;

    tr {
      cursor: pointer;

      &:hover {
        background-color: var(--elevation-2);
      }

      td {
        text-align: center;
      }
    }
  }
  .character {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-1);
    }
    .time {
      color: var(--text-dimmed);
    }
  }

  .show-all-button {
    cursor: pointer;
    margin-top: var(--space-4);
  }
</style>
